const INITIAL_STATE = {
    data: [],
    loading: false,
    error: false
};

export default function voucher(state = INITIAL_STATE, action){
    switch (action.type){
        case "ADD_VOUCHER":
            return { ...state, loading: true }
        case "SUCCESS_ADD_VOUCHER":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_ADD_VOUCHER":
            return { data: [], loading: false, error: true }
        case "REMOVE_VOUCHER":
            return { ...state, loading: true }
        case "SUCCESS_REMOVE_VOUCHER":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_REMOVE_VOUCHER":
            return { data: [], loading: false, error: true }
        case "UPDATE_VOUCHER":
            return { ...state, loading: true }
        case "SUCCESS_UPDATE_VOUCHER":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_UPDATE_VOUCHER":
            return { data: [], loading: false, error: true }
        case "CHECK_VOUCHER":
            return { ...state, loading: true }
        case "SUCCESS_CHECK_VOUCHER":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_CHECK_VOUCHER":
            return { data: [], loading: false, error: true }
        case "GET_VOUCHERS":
            return { ...state, loading: true }
        case "SUCCESS_GET_VOUCHERS":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_GET_VOUCHERS":
            return { data: [], loading: false, error: true }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/voucher.js